/*
Sohel 01/08/2023 2701335619 implemented Usage Functionality
Sohel 01/08/2023 2701335619 Fixed Download Usage Configuration Issue
Ravi 02/09/2023 2701335619 changed title from from framework to Data Management
//suresh peddavoora 02/24/2023 2701335619 New UI changes

*/
import React, {useEffect, useContext, useState} from 'react';
import capitalize from '../../../../../util/Capitalize';
import {useSelector, useDispatch} from 'react-redux';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../../components/CustomSnackBar';
import PageLoader from '../../../../../components/PageLoader';
import {Button, TablePagination} from '@material-ui/core';
import {ThemeContext} from './../../../../../themes/ThemeProvider';
import {postPrintUsage, resetPrintUsageData} from '../../../../../redux/reducers/printUsage';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import {ArrowBack} from '@material-ui/icons';
import {defaultRows} from '../../../../../constants/ReusableTablePagination';
import {tablePageRows} from '../../../../../constants/ReusableConstants';
import {resetDataManagerRecordGroupUsageData} from '../../../../../redux/reducers/DataManagerRecordGroup';
import {modulesText} from '../../../../../util/Content';

function DataManagerRecordGroupUsage({dataManagerRecordGroupData, setValue, exportManagerRecordGroup}) {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const {successMsg, errorMsg, isLoading, dataManagerRecordGroupUsage} =
  useSelector(({dataManagerRecordGroup}) => dataManagerRecordGroup);
  const dispatch = useDispatch();
  useEffect(() => {
    return () => {
      dispatch(resetDataManagerRecordGroupUsageData());
    };
  }, []);

  const [rows, setRows] = useState(defaultRows);
  const moduleType = exportManagerRecordGroup ? 'Export' : 'Import';
  const usageType =exportManagerRecordGroup ?'EXPORT RECORD GROUP' :'IMPORT RECORD GROUP';
  const {
    isLoading: printUsageIsLoading,
    successMsg: printUsageSuccessMsg,
    errorMsg: printUsageErrorMsg,
  } = useSelector(({printusage}) => printusage);

  useEffect(() => {
    if (printUsageSuccessMsg || printUsageErrorMsg) {
      setTimeout(() => {
        dispatch(resetPrintUsageData());
      }, 3000);
    }
  }, [printUsageSuccessMsg, printUsageErrorMsg]);

  const object = dataManagerRecordGroupUsage?.placeResponse ? dataManagerRecordGroupUsage?.placeResponse : {};

  const values = [];
  object &&
    Object.entries(object)?.forEach(([key, value]) => {
      value?.length > 0 &&
        value?.forEach((el, i) => {
          values.push({
            frameWork: key,
            codes: el?.code,
            description: el?.description ?? '',
          });
        });
    });
  const columns = [
    {
      title: modulesText,
      field: 'frameWork',
      render: (rowData) => {
        return rowData?.frameWork ? capitalize(rowData?.frameWork) : '--';
      },
    },
    {
      title: 'Name',
      field: 'codes',
      render: (rowData) => {
        return rowData?.codes ? rowData?.codes : '--';
      },
    },
    {
      title: 'Description',
      field: 'description',
      render: (rowData) => {
        return rowData?.description ? rowData?.description : '--';
      },
    },
  ];
  return (
    <div>
      <div className={` mb-0`}>
        <div className="button-table-spacing-mb justify-content-start new-standard-textfields">
          <Button
            variant="outlined"
            type="button"
            className={`search-btn mx-1`}
            onClick={() => {
              setValue(0);
            }}
          >
            <ArrowBack className="mr-2" />
            Back To Search
          </Button>
        </div>
        <div className="custom-table custom-toolbar-icons global-field-table new-standard-textfields">
          <GuiTable
            title={`${dataManagerRecordGroupData?.groupCode} - ${dataManagerRecordGroupData?.groupDescription} This ${moduleType} 
            Record Group has been used in the following places.`}
            columns={columns}
            data={values}
            textAlign="left"
            options={{
              paging: true,
              toolbar: true,
              search: false,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
                fontSize: '0.938rem',
                padding: '16px',
              },
              pageSize: rows,
              pageSizeOptions: tablePageRows,
            }}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer ">
                  <div className="mt-2">
                    <Button
                      type="button"
                      variant="outlined"
                      className={`mx-1 search-btn ${classes.buttonRoot}`}
                      color="primary"
                      disabled={dataManagerRecordGroupUsage.userMetrix === 'No'}
                      onClick={(event) => {
                        dispatch(
                          postPrintUsage({
                            baseCategory: '',
                            code: '',
                            description: '',
                            displayName: '',
                            fileType: '',
                            recordFormatType: '',
                            returnType: '',
                            sourceType: usageType,
                            isDraft: '',
                            search: '',
                            frameworkUsageOrderBy: '',
                            frameworkUsageOrderDerection: '',
                            fieldListOrderBy: '',
                            fieldListOrderDerection: '',
                            category: dataManagerRecordGroupData?.category ? dataManagerRecordGroupData?.category : '',
                            includeAudit: dataManagerRecordGroupData?.includeAudit ? dataManagerRecordGroupData?.includeAudit : '',
                            fieldName: '',
                            repositoryDescription: '',
                            repositoryName: '',
                            repositoryType: '',
                            createdBy: '',
                            groupCode: dataManagerRecordGroupData?.groupCode ? dataManagerRecordGroupData?.groupCode : '',
                            groupType: dataManagerRecordGroupData?.groupType ? dataManagerRecordGroupData?.groupType : '',
                            groupDescription: dataManagerRecordGroupData?.groupDescription ?
                              dataManagerRecordGroupData?.groupDescription :
                              '',
                            createdDate: '',
                          }),
                        );
                      }}
                    >
                      Download Configuration Usage
                    </Button>
                  </div>
                  <div className="w-50" style={{backgroundColor: 'white', border: '0px'}}>
                    <TablePagination
                      {...props}
                      SelectProps={{
                        inputProps: {'aria-label': 'Rows per screen'},
                      }}
                      labelRowsPerPage={'Rows per screen:'}
                      rowsPerPageOptions={tablePageRows}
                      onChangeRowsPerPage={(event) => {
                        props.onChangeRowsPerPage(event);
                        setRows(event.target.value);
                      }}
                    />
                  </div>
                </div>
              ),
            }}
          />
        </div>
      </div>
      {(isLoading || printUsageIsLoading) && <PageLoader />}
      {(errorMsg || printUsageErrorMsg) && (
        <ErrorSnackbar errorMsg={errorMsg || printUsageErrorMsg} />
      )}
      {(successMsg || printUsageSuccessMsg) && (
        <SuccessSnackbar successMsg={successMsg || printUsageSuccessMsg} />
      )}
    </div>
  );
}

export default DataManagerRecordGroupUsage;
